import { HelperWrapper } from 'src/components/helper-wrapper'
import { E2FATab, ETranslationNs } from 'src/types'
import { useStyles } from '../styles'

interface IProps {
  tab: E2FATab
}

export const TwoFANone = ({ tab }: IProps) => {
  const classes = useStyles()

  if (tab !== E2FATab.None) {
    return null
  }

  return (
    <div className={classes.noneWrapper}>
      <h3 className={classes.sectionTitle}>
        <HelperWrapper t="2fa-none-title" ns={ETranslationNs.UserProfile} />
      </h3>
      <p className={classes.sectionText}>
        <HelperWrapper t="2fa-none-text" ns={ETranslationNs.UserProfile} />
      </p>
    </div>
  )
}
